export const Actions = {
  SIGN_IN_SUCCESS: '@auth/SIGN_IN_SUCCESS',
};
